import React from 'react';
import ContentPage from '../ContentPage/ContentPage';
import WithdrawalForm from 'View/Component/WithdrawalForm/WithdrawalForm';

const RevocationPage: React.FC = () => (
  <ContentPage slug="widerruf" title="Widerruf">
    <WithdrawalForm />
  </ContentPage>
);

export default RevocationPage;
